import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import UsersList from '../components/Users/UsersList';
import GodView from '../components/Users/GodView';
import IdentityOptions from '../components/Users/IdentityOptions';
import ProfileMigration from '../components/Users/ProfileMigration';
import AllUsersTab from './Users/AllUsersTab/AllUsersTab';

const Users: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Get current tab from URL parameter
  const getCurrentTab = () => {
    const tab = searchParams.get('tab');
    switch (tab) {
      case 'all-users':
        return 'all-users';
      case 'users-list':
        return 'users-list';
      case 'god-view':
        return 'god-view';
      case 'identity-options':
        return 'identity-options';
      case 'profile-migration':
        return 'profile-migration';
      default:
        return 'users-list';
    }
  };

  // Set default tab parameter if none exists
  useEffect(() => {
    if (!searchParams.get('tab')) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('tab', 'users-list');
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const currentTab = getCurrentTab();

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ 
        flexGrow: 1,
        overflow: 'hidden',
      }}>
        {currentTab === 'all-users' && <AllUsersTab />}
        {currentTab === 'users-list' && <UsersList />}
        {currentTab === 'god-view' && <GodView />}
        {currentTab === 'identity-options' && <IdentityOptions />}
        {currentTab === 'profile-migration' && <ProfileMigration />}
      </Box>
    </Box>
  );
};

export default Users; 